/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
      caches.keys().then(function(names) {
        console.log("In caches")
        console.log(names)
        if(names.length > 0) {
          console.log("Have caches")
          for (let name of names){
            console.log(name)
            caches.delete(name);
            // setTimeout(() => {
            //   window.location.reload(true)
            // }, 10000)
          }
        }else{
          console.log("No caches")
        } 
      });
      
    },
    updated () {
      console.log('New content is available; please refresh.')
      
      // setTimeout(function(){ location.reload(); }, 1000);
      // caches.keys().then(function(names) {
      //   console.log("In caches")
      //   console.log(names)
      //   if(names.length > 0) {
      //     console.log("Have caches")
      //     for (let name of names){
      //       console.log(name)
      //       caches.delete(name);
      //     }
      //   }else{
      //     console.log("No caches")
      //   } 
      // });
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
